const lastEventAt = new Map<number, number>();

export const noteHubEvent = (callId: unknown): void => {
  if (typeof callId === 'number') lastEventAt.set(callId, Date.now());
};

export const lastHubEventAt = (callId: number): number | undefined => lastEventAt.get(callId);
